import React, { useState } from 'react';
import { FiTrash2, FiX, FiAlertTriangle } from 'react-icons/fi';
import './DeleteModal.css';

const DeleteModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Delete Item",
  description = "Are you sure you want to delete this item?",
  itemName = "",
  icon: CustomIcon = FiTrash2,
  confirmText = "DELETE",
  cancelText = "CANCEL",
  requireTextConfirmation = true,
  confirmationText = "delete"
}) => {
  const [confirmationInput, setConfirmationInput] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    if (requireTextConfirmation && confirmationInput.toLowerCase() !== confirmationText.toLowerCase()) {
      return;
    }

    setIsDeleting(true);
    try {
      await onConfirm();
      handleClose();
    } catch (error) {
      console.error('Delete failed:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleClose = () => {
    setConfirmationInput('');
    setIsDeleting(false);
    onClose();
  };

  const isConfirmDisabled = requireTextConfirmation 
    ? confirmationInput.toLowerCase() !== confirmationText.toLowerCase() 
    : false;

  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        {/* Header */}
        <div className="delete-modal-header">
          <h2>Delete {title}</h2>
          <button 
            className="delete-modal-close"
            onClick={handleClose}
            disabled={isDeleting}
          >
            <FiX />
          </button>
        </div>

        {/* Content */}
        <div className="delete-modal-body">
          <div className="delete-warning-section">
            <div className="delete-icon-container">
              <CustomIcon className="delete-icon" />
            </div>
            <div className="delete-text-content">
              <h3>Delete {itemName ? `"${itemName}"` : 'this item'}?</h3>
              <p>{description}</p>
            </div>
          </div>

          {requireTextConfirmation && (
            <div className="confirmation-input-section">
              <label htmlFor="confirmation-input">
                Type <strong>"{confirmationText}"</strong> to confirm:
              </label>
              <textarea
                id="confirmation-input"
                value={confirmationInput}
                onChange={(e) => setConfirmationInput(e.target.value)}
                placeholder={`Type "${confirmationText}" here...`}
                rows={2}
                disabled={isDeleting}
              />
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="delete-modal-actions">
          <button 
            type="button"
            className="cancel-delete-btn"
            onClick={handleClose}
            disabled={isDeleting}
          >
            {cancelText}
          </button>
          <button 
            type="button"
            className="confirm-delete-btn"
            onClick={handleConfirm}
            disabled={isConfirmDisabled || isDeleting}
          >
            {isDeleting ? (
              <>
                <div className="loading-spinner"></div>
                DELETING...
              </>
            ) : (
              <>
                <FiTrash2 />
                {confirmText}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
